module.exports = __webpack_public_path__ + "img/shareios.7c60be31.svg";